import ShopApi from '@apis/shop/ShopApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetShopsInMapParams, GetShopsParams } from '@models/shop';

const shopQueries = createQueryKeys('shop', {
    listInfinite: (params: Omit<GetShopsParams, 'page'>) => ({
        queryKey: [params], // queryFn: () => ShopApi.getShops(params),
    }),
    list: (params: GetShopsParams) => ({
        queryKey: [params],
        queryFn: () => ShopApi.getShops(params),
    }),
    mapList: (params: GetShopsInMapParams) => ({
        queryKey: [params],
        queryFn: () => ShopApi.getShopsInMap(params),
    }),
    detail: (shopId: string) => ({
        queryKey: [shopId],
        queryFn: () => ShopApi.getShop(shopId),
    }),
});

export default shopQueries;
